import React from 'react'
import Translation from '../../../Translation/cont/Translation'

const ConfirmDialog = ({ titleTransId, bodyTransId, onConfirm, onCancel }) => (
    <div className="dialog-overlay" onClick={onCancel}>
        <div className="dialog" onClick={e => e.stopPropagation()}>
            <div className="dialog-header">
                <span className="dialog-title text-small-regular"><Translation id={titleTransId} /></span>
            </div>
            <div className="dialog-body dialog-body--padded">
                <p><Translation id={bodyTransId} /></p>
            </div>
            <div className="dialog-footer">
                <button className="dlg-btn-cancel" onClick={onCancel}><Translation id="cancel_button" /></button>
                <button className="dlg-btn-ok" onClick={onConfirm}><Translation id="confirm_button" /></button>
            </div>
        </div>
    </div>
)

export default ConfirmDialog
